async function importModalVideo() {
  const { default: ModalVideo } = await import('modal-video')
  return ModalVideo
}

const videoButtons = document.querySelectorAll('.js-modal-btn')
if (videoButtons.length > 0) {
  importModalVideo().then((ModalVideo) => {
    new ModalVideo(videoButtons);
  })
}

videoButtons.forEach(button => {
  button.addEventListener('click', e => {
    const video = button.querySelector('video')
    if (video) {
      video.pause()
    }
  })
})